/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './verification.defs.js'
export { main as default } from './verification.defs.js'
